import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/AppShell";
import { authClient } from "@/lib/authClient";

// redirect() devuelve un Response, no un Error, así que un `throw redirect(...)`
// directo dispara only-throw-error. Se usa como función de aserción (con la
// opción `throw` del propio redirect, que lo lanza por dentro) para que
// TypeScript siga estrechando `user` tras el guard sin que quede ningún
// `throw` de un valor no-Error en el código propio.
function assertSignedIn<T>(user: T | null | undefined): asserts user is T {
  if (!user) redirect({ to: "/entrar", throw: true });
}

export const Route = createFileRoute("/_auth")({
  async beforeLoad() {
    const { data } = await authClient.getSession();
    const user = data?.user;
    assertSignedIn(user);
    return { user };
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  const { user } = Route.useRouteContext();

  return (
    <AppShell
      user={{ name: user.name, email: user.email, role: user.role ?? "ir_analyst" }}
    >
      <Outlet />
    </AppShell>
  );
}
